module.exports = __webpack_public_path__ + "static/media/top-wave.b7032910.svg";